<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">Авторизация в Приват24 для бизнеса - Введите СМС</h2>

    <privat-otp-auth-form @after="handleAfter" />

  </div>
</template>

<script>
import privatOtpAuthForm from '@/components/forms/privat_otp_auth/PrivatOtpAuthForm'

export default {
  name: 'privat-otp-auth',
  components: { privatOtpAuthForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'bank-transactions' })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// PrivatOtpAuth.vue?70cd9942